<template>
  <b-modal
    id="export-portfolio-modal"
    size="lg"
    :title="$t('portfolioManager.exportPortfolio.exportPortfolios')"
    cancel-variant="primary"
    ok-variant="secondary"
    :ok-title="$t('general.export')"
    :cancel-title="$t('general.cancel')"
    centered
    @ok="handleOkSumbit"
    :ok-disabled="selectedItems.length === 0"
     @hide="handleClose"
  >
    <p class="subtitle">
      {{ $t("portfolioManager.exportPortfolio.subtitle") }}
    </p>
    <simple-form-input
        v-model="name"
        :disabled="includeHistory"
        :label="$t('portfolioManager.savePortfolio.inputLabel')"
    />
    <div class="modal-row">
        <div>
            <b-form-checkbox
                v-model="includeHistory"
                class="checkbox"
            >
           {{$t('portfolioManager.exportPortfolio.includeHistory')}}
            </b-form-checkbox>
            <span class="info" v-if="includeHistory">{{$t('portfolioManager.exportPortfolio.includeHistoryNote')}}</span>
        </div>
        <simple-form-input
            type="text"
            :label="$t('general.search')"
            v-model="filter"
            class="filter-input"
        >
            <template v-slot:leadingIcon><search-icon :size="18" /></template>
        </simple-form-input>
    </div> 
    <div class="portfolios-container slim-scroll">
        <div class="flex align-center space-between">
            <span class="title">{{$t('portfolioManager.portfoliosSidebar.title')}}: </span>
            <div class="flex">
                <b-button
                    @click="handleUnselectAll"
                    variant="blank"
                    class="margin-left-auto select-all-button"
                    v-if="selectedItems.length"
                >
                {{$t('general.unselectAll')}}
                </b-button>
                <b-button
                    @click="handleSelectAll"
                    variant="primary"
                    class="margin-left-auto select-all-button"
                >
                {{$t('general.selectAll')}}
                </b-button>
            </div>
        </div>
      <ul class="options-container slim-scroll">
        <li
          v-for="item in items"
          :key="item.portfolio_id"
          :class="[
            { active: selectedItems.includes(item) },
            'list-item',
          ]"
          @click="addToActive(item)"
        >
            <div class="selected-item"/>
            <file-icon :size="20"/>
          {{item.portfolio_name}}
        </li>
      </ul>
    </div>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import FileIcon from "vue-material-design-icons/FileDocumentOutline.vue";
import SearchIcon from "vue-material-design-icons/Magnify.vue";
import SimpleFormInput from "../inputs/SimpleFormInput.vue";
export default {
  name: "export-portfolio-modal",
  components: {
    FileIcon,
    SearchIcon,
    SimpleFormInput
  },
  data() {
    return {
     selectedItems: [],
     name: "",
     selectAll: false,
     includeHistory: false,
     filter: ""
    };
  },
  computed: {
    ...mapGetters("portfolioManagerStore", ["savedPortfolios"]),
    items(){
      let filtered = this.savedPortfolios;
      if (this.filter !== "") {
        filtered = filtered.filter((o) =>
          Object.keys(o).some(
            (k) =>
              k === "portfolio_name" &&
              o[k].includes(this.filter)
          )
        );
      }
      return filtered;
    }
  },
  methods: {
    ...mapActions("portfolioManagerStore", ["getSavedPortfolios", "downloadPortfolioExcel", "downloadPortfolioExcelHistory"]),
     addToActive(item) {
      if (this.selectedItems.includes(item)) {
        const index = this.selectedItems.indexOf(item);
        this.selectedItems.splice(index, 1);
      } else {
        this.selectedItems.push(item);
      }
    },
    handleSelectAll(){
      this.selectedItems = [...this.savedPortfolios];
    },
    handleUnselectAll(){
      this.selectedItems = [];
    },
    handleClose(){
        this.handleUnselectAll();
        this.name = "";
        this.selectAll = false,
        this.includeHistory = false,
        this.filter =  "";
    },
    handleOkSumbit() {
      const idItems = [];
      const portfolios = [];
      this.selectedItems.forEach(item  => {
        idItems.push(item.last_history_obj.history_id);
        const data = {
          id: item.portfolio_id,
          name: item.portfolio_name
        }
        portfolios.push(data);
      });
      if(!this.includeHistory){
        this.downloadPortfolioExcel({portfolios: idItems, name: this.name});
      }
      else{
        this.downloadPortfolioExcelHistory(portfolios);
      }
    },
  },
  mounted() {
   this.getSavedPortfolios();
   this.handleUnselectAll();
  },
};
</script>

<style lang="scss" scoped>
.modal-row{
    padding-bottom: toRem(12);
    margin-top: -5px;
    display: flex;
    justify-content: space-between;
    .inputHelper{
        display: none
    }
}
.portfolios-container{
    @include dps-box;
    min-height: toRem(250);
    max-height: 30vh;
    padding-top: toRem(10);
    padding-bottom: toRem(10);
    position: relative;
    padding-right: toRem(10);
    ul{
        margin-bottom: 0;
        padding-left: 0;
        margin-left: -8px;
        display: flex;
        flex-wrap: wrap;
        column-gap: 40px;
        .list-item{
            list-style: none;
            height: toRem(30);
            display: flex;
            align-items: center;
            width: calc(50% - 20px);
            cursor: pointer;
            .material-design-icon{
                margin-right: toRem(5);
            }
            .selected-item{
                padding-right: 3px;
                &::before{
                    content: '';
                    display: inline-block;
                    width: 8px;
                    height: 8px;
                    -moz-border-radius: 7.5px;
                    -webkit-border-radius: 7.5px;
                    border-radius: 7.5px;
                    background-color: #ffffff;
                }
            }
            &.active{
                color: $primaryColor;
                font-weight: 500;
                .selected-item{
                    &::before{
                        background-color: $primaryColor;
                    }
                }
            }
        }
    }
    .title{
        padding-left: 3px;
        font-weight: 600;
        font-size: toRem(14);
    }
}

</style>